// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { TraceHandler } from "./handler.js";
